var map = {
	"./0.jpeg": 1956,
	"./1.jpeg": 5291,
	"./2.jpeg": 7598,
	"./3.jpeg": 5877,
	"./4.jpeg": 2736,
	"./5.jpeg": 3655,
	"./6.jpeg": 298,
	"./7.jpeg": 6193,
	"./8.jpeg": 1036,
	"./9.jpeg": 1619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4580;